<template>
	<article
		v-click-outside="onClickOutside"
		ref="filter"
		class="a-select-date-filter"
	>
		<button
			class="a-select-date-filter__trigger"
			:class="{ active: listVisible }"
			type="button"
			@click="showList"
		>
			{{ text }}
		</button>
		<ul v-show="listVisible" class="a-select-date-filter__dropdown">
			<li ref="periodItems" class="a-select-date-filter__item">
				<span
					@click.prevent.stop="resetCalendar"
					@mouseover="setHoverOnListItem"
					@mouseleave="removeHoverOnListItem"
					ref="allTime"
				>
					{{ optionAllTime.text }}
				</span>
				<span
					@click.prevent.stop="showCalendar"
					@mouseover="setHoverOnListItem"
					@mouseleave="removeHoverOnListItem"
					ref="period"
				>
					{{ optionPeriod.text }}
				</span>
				<datepicker-select
					ref="dpSelect"
					class="a-select-date-filter__datepick"
					:is-month-mode="monthMode"
					:is-range-mode="rangeMode"
					:presetDate="presetDate"
					:min-date="minDate"
					:max-date="maxDate"
					:clearable="isClearable"
					@select-date="getNewDate"
					@click="setCoordsToCalendar"
					@reset-date="clearDatepicker"
					@closed="closeDatepicker"
					:alt-position="() => {}"
				/>
			</li>
		</ul>
	</article>
</template>

<script>
import DatepickerSelect from '../../vue-components/DatepickerSelect'
import getCoords from '../../modules/get-element-coords'
import vClickOutside from 'click-outside-vue3'

export default {
	name: 'SelectDateFilter',
	directives: {
		clickOutside: vClickOutside.directive,
	},
	components: {
		DatepickerSelect,
	},
	data() {
		return {
			text: 'За все время',
			listVisible: false,
			rangeMode: true,
			monthMode: false,
			presetDate: null,
			minDate: null,
			maxDate: null,
			dateStart: null,
			dateEnd: null,
			isClearable: true,
			optionAllTime: {
				text: 'За все время',
				id: 'allTime',
			},
			optionPeriod: {
				text: 'Выбрать период',
				id: 'period',
			},
		}
	},
	methods: {
		showList() {
			this.listVisible = !this.listVisible
		},

		clearDatepicker() {
			this.listVisible = false
			this.text = this.optionAllTime.text
			this.dateStart = null
			this.dateEnd = null
			this.$emit('optionSelected', 'allTime')
		},

		closeDatepicker() {
			this.$nextTick(() => {
				if (!this.dateStart) {
					this.text = this.optionAllTime.text
				}
			})
		},

		getCurrentDate() {
			this.maxDate = new Date()
		},

		getNewDate(newDate) {
			this.listVisible = false
			let days = []
			let monthes = []

			newDate.forEach(el => {
				let day = el.getDate()
				let month = el.getMonth() + 1

				if (+day < 10) {
					day = `0${day}`
				}
				if (+month < 10) {
					month = `0${month}`
				}

				days.push(day)
				monthes.push(month)
			})

			this.dateStart = `${newDate[0].getDate()}.${
				newDate[0].getMonth() + 1
			}.${newDate[0].getFullYear()}`
			this.dateEnd = `${newDate[1].getDate()}.${
				newDate[1].getMonth() + 1
			}.${newDate[1].getFullYear()}`

			this.text = `
                    ${days[0]}.${monthes[0]}.${newDate[0].getFullYear()}
                    -
                    ${days[1]}.${monthes[1]}.${newDate[1].getFullYear()}`
			this.$emit('dateSelected', this.dateStart, this.dateEnd)
		},

		setCoordsToCalendar() {
			if (!this.dateStart) {
				this.text = this.optionPeriod.text
			}

			const calendar = document.querySelector('.dp__menu.dp__menu_index')
			const target = this.$refs.filter
			const MARGIN_TOP = 5

			calendar.style.top = `${
				getCoords(target).top + target.offsetHeight + MARGIN_TOP
			}px`
			if (window.innerWidth > 1024) {
				calendar.style.left = `${getCoords(target).right}px`
				calendar.style.transform = 'translateX(-100%)'
				return
			}

			calendar.style.left = `${getCoords(target).left}px`
		},

		onClickOutside() {
			if (this.listVisible) {
				setTimeout(() => {
					this.listVisible = false
				}, 100)
			}
		},

		setHoverOnListItem() {
			event.target.classList.add('hover')
		},

		removeHoverOnListItem() {
			event.target.classList.remove('hover')
		},

		showCalendar() {
			this.$refs.dpSelect.$refs.dp.openMenu()
			this.$nextTick(() => {
				this.setCoordsToCalendar()
				this.onClickOutside()
			})
		},

		resetCalendar() {
			this.$refs.dpSelect.$refs.dp.clearValue()
		},
	},
	mounted() {
		this.getCurrentDate()
	},
}
</script>
